<template>
  <svg
    enable-background="new 0 0 512 512"
    height="512"
    viewBox="0 0 512 512"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M205 67 A196 196 0 1 1 67 205 L109 217 A152 152 0 1 0 217 109 Z" />
    <path d="M198 38 L224 138 L134 109 Z" />
    <circle cx="256" cy="205" r="46" />
    <path d="M172 352 a84 82 0 0 1 168 0 z" />
  </svg>
</template>
